module.exports = __webpack_public_path__ + "media/images/nipa_brew-7b056ddd1f3755df32c56d5fa72ee17c.png";